export const formatUserName = (
  firstName?: string,
  lastName?: string,
): string | null => [firstName, lastName].filter(Boolean).join(' ')
